module.exports = new __parcel__URL__("puzzle.10499b33.png").toString();